import { api } from './api';

export const getSessions = async (data) =>{  
  return await api.get('sessions', data)
};

export const sessionCreate = async (data) =>{
  return await api.post('Session/create', data)
};

export const sessionDelete = async (id) => {
  return await api.get(`Session/Delete/${id}`);
};

export const sessionStatus = async (data)=>{
  return await api.post(`Session/Status`, data)
}

